import API from "./API";

export default class ContractDocument extends API {
  constructor(parameters = {}) {
    super("/ContractDocument", parameters);
  }

  getContractsByLesseeId(lessee) {
    return this.submit("get", `${this.endpoint}/${lessee}`);
  }

  getAllContractDocuments() {
    return this.submit("get", `${this.endpoint}/all`);
  }
}
